/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElContextMenuDirective } from './context-menu.directive';
import { ElContextMenuComponent } from './context-menu.component';
import { ElMenuModule } from '../menu/menu.module';


@NgModule({
  imports: [CommonModule, ElOverlayModule, ElMenuModule],
  exports: [ElContextMenuDirective],
  declarations: [ElContextMenuDirective, ElContextMenuComponent],
  entryComponents: [ElContextMenuComponent],
})
export class ElContextMenuModule {
}
